var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "myskov-profile" },
    [
      _vm.customerLoading && !_vm.customer
        ? _c("msg-block", [
            _c("p", [
              _c("b", {
                domProps: { textContent: _vm._s(_vm.translations.loading) }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.customer
        ? _c(
            "div",
            { staticClass: "profile-block" },
            [
              _c("div", { staticClass: "profile-block__intro" }, [
                _c("div", { staticClass: "profile-picture" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 27.04 26.96"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M26,27H1a1,1,0,0,1-.59-1.81,21.19,21.19,0,0,1,7.94-3.54,1,1,0,0,0,.83-1c0-.54,0-1.12,0-1.73a5.16,5.16,0,0,0-.79-2.21,6.94,6.94,0,0,1-1-2.78,7.83,7.83,0,0,1-.87-3.18,1.65,1.65,0,0,1,.4-1.22c-.07-.34-.13-.7-.19-1.06l0-.17c-.06-.37-.12-.71-.18-1C6,4.11,7,2.18,9.78.92L9.9.85A6.56,6.56,0,0,1,12.55.06a7.45,7.45,0,0,1,3.26.32l.37.09c.44.11.79.21,1,.28,2.72,1,3.9,3.26,3.33,6.45-.07.35-.12.7-.18,1s-.14.83-.22,1.23a1.65,1.65,0,0,1,.4,1.22,7.7,7.7,0,0,1-.88,3.18,7,7,0,0,1-1,2.86,5.13,5.13,0,0,0-.76,2.14c0,.6,0,1.18,0,1.73a1,1,0,0,0,.83,1,21.21,21.21,0,0,1,7.93,3.54A1,1,0,0,1,26,27ZM4.65,25H22.39a16,16,0,0,0-4.05-1.38,3,3,0,0,1-2.48-3.07c0-.52,0-1.07,0-1.64a6.67,6.67,0,0,1,1-3.06,5.89,5.89,0,0,0,.77-2,2.08,2.08,0,0,1,.19-.77,6,6,0,0,0,.68-2.31v0a2,2,0,0,1-.36-1.56c.07-.38.14-.78.2-1.19s.12-.71.19-1.07c.53-2.94-.9-3.8-2-4.2-.17-.06-.47-.14-.83-.23l-.38-.09a5.53,5.53,0,0,0-2.54-.27,4.59,4.59,0,0,0-2,.59l-.17.09c-2,.9-2.53,1.93-2.14,4.11l.18,1,0,.21q.09.53.18,1a2,2,0,0,1-.36,1.56v0A5.86,5.86,0,0,0,9.21,13a2,2,0,0,1,.19.77,5.3,5.3,0,0,0,.75,2,6.94,6.94,0,0,1,1,3.15c0,.57,0,1.12,0,1.64A3,3,0,0,1,8.7,23.58,16,16,0,0,0,4.65,25Zm3.7-14.09h0Zm10.34,0Z"
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-block__intro__text" }, [
                  _c("h2", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.translations.title.replace(
                          /{name}/,
                          _vm.customer.firstName
                        )
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.translations.member_since)
                      }
                    }),
                    _vm._v(" " + _vm._s(_vm.memberSinceDate))
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.translations.last_ip)
                      }
                    }),
                    _vm._v(" " + _vm._s(_vm.customer.lastLoginIp))
                  ])
                ]),
                _vm._v(" "),
                !_vm.showCloseAccountInfoBox
                  ? _c("button", {
                      staticClass: "btn btn--negative",
                      domProps: {
                        textContent: _vm._s(_vm.translations.close_account)
                      },
                      on: {
                        click: function($event) {
                          _vm.showCloseAccountInfoBox = true
                        }
                      }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.showCloseAccountInfoBox
                ? _c("msg-block", { attrs: { type: "warning" } }, [
                    _c("p", [
                      _c("b", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.translations.close_account_check
                          )
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "input-fields" },
                      [
                        _c(
                          "div",
                          { staticClass: "input-fields__content" },
                          [
                            _c("input-field", {
                              staticClass:
                                "booking-field booking-field--firstname",
                              attrs: { value: _vm.closeAccountTxt },
                              on: {
                                input: function(inp) {
                                  return (_vm.closeAccountTxt = inp)
                                },
                                enter: _vm.closeAccount
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.closeAccountError
                          ? _c("msg-block", { attrs: { type: "error" } }, [
                              _c("p", [
                                _c("b", {
                                  domProps: {
                                    textContent: _vm._s(_vm.closeAccountError)
                                  }
                                })
                              ])
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.customer
        ? _c(
            "div",
            { staticClass: "profile-block" },
            [
              _c("div", { staticClass: "profile-block__heading" }, [
                _c("h3", {
                  domProps: {
                    textContent: _vm._s(_vm.translations.update_profile_title)
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "profile-block__text" }, [
                _c("p", {
                  domProps: {
                    textContent: _vm._s(_vm.translations.update_profile_txt)
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-fields" },
                [
                  _c(
                    "div",
                    { staticClass: "input-fields__content" },
                    [
                      _c("input-field", {
                        staticClass: "booking-field booking-field--firstname",
                        attrs: {
                          name: _vm.translations.input_firstname,
                          value: _vm.customer.firstName
                        },
                        on: {
                          input: function(inp) {
                            return _vm.$set(_vm.customer, "firstName", inp)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input-field", {
                        staticClass: "booking-field booking-field--lastname",
                        attrs: {
                          name: _vm.translations.input_lastname,
                          value: _vm.customer.lastName
                        },
                        on: {
                          input: function(inp) {
                            return _vm.$set(_vm.customer, "lastName", inp)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.errors.firstName || _vm.errors.lastName
                    ? _c("msg-block", { attrs: { type: "error" } }, [
                        _vm.errors.firstName
                          ? _c("p", [
                              _c("b", {
                                domProps: {
                                  textContent: _vm._s(_vm.errors.firstName[0])
                                }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.lastName
                          ? _c("p", [
                              _c("b", {
                                domProps: {
                                  textContent: _vm._s(_vm.errors.lastName[0])
                                }
                              })
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-fields" },
                [
                  _c("div", { staticClass: "input-fields__header" }, [
                    _c("h3", {
                      domProps: {
                        textContent: _vm._s(_vm.translations.address_hader)
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-fields__content" },
                    [
                      _c("input-field", {
                        staticClass: "booking-field booking-field--address",
                        attrs: {
                          name: _vm.translations.input_address,
                          value: _vm.customer.address
                        },
                        on: {
                          input: function(inp) {
                            return _vm.$set(_vm.customer, "address", inp)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.errors.address
                    ? _c("msg-block", { attrs: { type: "error" } }, [
                        _vm.errors.address
                          ? _c("p", [
                              _c("b", {
                                domProps: {
                                  textContent: _vm._s(_vm.errors.address[0])
                                }
                              })
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-fields" },
                [
                  _c(
                    "div",
                    { staticClass: "input-fields__content" },
                    [
                      _c("input-field", {
                        staticClass: "booking-field booking-field--zipcode",
                        attrs: {
                          name: _vm.translations.input_postal,
                          "input-type": "tel",
                          value: _vm.customer.zipCode,
                          mask: "9999"
                        },
                        on: {
                          input: function(inp) {
                            return _vm.$set(
                              _vm.customer,
                              "zipCode",
                              inp.substr(0, 4)
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input-field", {
                        staticClass: "booking-field booking-field--city",
                        attrs: {
                          name: _vm.translations.input_town,
                          value: _vm.customer.city
                        },
                        on: {
                          input: function(inp) {
                            return _vm.$set(_vm.customer, "city", inp)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.errors.zipCode || _vm.errors.city
                    ? _c("msg-block", { attrs: { type: "error" } }, [
                        _vm.errors.zipCode
                          ? _c("p", [
                              _c("b", {
                                domProps: {
                                  textContent: _vm._s(_vm.errors.zipCode[0])
                                }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.city
                          ? _c("p", [
                              _c("b", {
                                domProps: {
                                  textContent: _vm._s(_vm.errors.city[0])
                                }
                              })
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-fields" },
                [
                  _c(
                    "div",
                    { staticClass: "input-fields__content" },
                    [
                      _c("selector", {
                        staticClass: "booking-field booking-field--country",
                        attrs: {
                          options: _vm.countries,
                          "icon-type": "drop-down"
                        },
                        model: {
                          value: _vm.customer.countryCode,
                          callback: function($$v) {
                            _vm.$set(_vm.customer, "countryCode", $$v)
                          },
                          expression: "customer.countryCode"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.errors.countryCode
                    ? _c("msg-block", { attrs: { type: "error" } }, [
                        _vm.errors.countryCode
                          ? _c("p", [
                              _c("b", {
                                domProps: {
                                  textContent: _vm._s(_vm.errors.countryCode[0])
                                }
                              })
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-fields" },
                [
                  _c("div", { staticClass: "input-fields__header" }, [
                    _c("h3", {
                      domProps: {
                        textContent: _vm._s(_vm.translations.contact_header)
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-fields__content" },
                    [
                      _c("input-field", {
                        staticClass: "booking-field booking-field--mail",
                        attrs: {
                          name: _vm.translations.input_email,
                          "input-type": "email",
                          value: _vm.customer.email
                        },
                        on: {
                          input: function(inp) {
                            return _vm.$set(_vm.customer, "email", inp)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.errors.email
                    ? _c("msg-block", { attrs: { type: "error" } }, [
                        _vm.errors.email
                          ? _c("p", [
                              _c("b", {
                                domProps: {
                                  textContent: _vm._s(_vm.errors.email[0])
                                }
                              })
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-fields" },
                [
                  _c(
                    "div",
                    { staticClass: "input-fields__content" },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "booking-field booking-field--countrycode-text"
                        },
                        [_vm._v("+")]
                      ),
                      _vm._v(" "),
                      _c("input-field", {
                        staticClass: "booking-field booking-field--countrycode",
                        attrs: {
                          name: _vm.translations.input_countrycode,
                          mask: "99",
                          "input-type": "tel",
                          value: _vm.phone_contrycode
                        },
                        on: {
                          input: function(inp) {
                            return (this$1.phone_contrycode = inp.substr(0, 2))
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input-field", {
                        staticClass: "booking-field booking-field--phone",
                        attrs: {
                          name: _vm.translations.input_phone,
                          "input-type": "tel",
                          value: _vm.phone_number
                        },
                        on: {
                          input: function(inp) {
                            return (this$1.phone_number = inp)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.errors.phone
                    ? _c("msg-block", { attrs: { type: "error" } }, [
                        _vm.errors.phone
                          ? _c("p", [
                              _c("b", {
                                domProps: {
                                  textContent: _vm._s(_vm.errors.phone[0])
                                }
                              })
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("button", {
                staticClass: "btn btn--info",
                class: { "item-loading": _vm.customerLoading },
                attrs: { disabled: _vm.customerLoading },
                domProps: {
                  textContent: _vm._s(_vm.translations.update_profile_btn)
                },
                on: { click: _vm.updateProfile }
              }),
              _vm._v(" "),
              _vm.customerError
                ? _c("msg-block", { attrs: { type: "error" } }, [
                    _c("p", [
                      _c("b", {
                        domProps: { textContent: _vm._s(_vm.customerError) }
                      })
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.customerSuccess
                ? _c("msg-block", { attrs: { type: "success" } }, [
                    _c("p", [
                      _c("b", {
                        domProps: {
                          textContent: _vm._s(_vm.translations.customer_success)
                        }
                      })
                    ])
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.customer
        ? _c("div", { staticClass: "profile-block" }, [
            _c("div", { staticClass: "profile-block__heading" }, [
              _c("h3", {
                domProps: {
                  textContent: _vm._s(_vm.translations.password_header)
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-fields" },
              [
                _c("div", { staticClass: "input-fields__header" }, [
                  _c("h3", {
                    domProps: {
                      textContent: _vm._s(_vm.translations.input_old_password)
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-fields__content" },
                  [
                    _c("input-field", {
                      staticClass: "booking-field booking-field--mail",
                      attrs: {
                        name: _vm.translations.input_old_password,
                        "input-type": "password",
                        value: _vm.oldpassword
                      },
                      on: {
                        input: function(val) {
                          return (_vm.oldpassword = val)
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.pw_errors.oldpassword
                  ? _c(
                      "msg-block",
                      { attrs: { type: "error" } },
                      _vm._l(_vm.pw_errors.oldpassword, function(error) {
                        return _c("p", [
                          _c("b", { domProps: { textContent: _vm._s(error) } })
                        ])
                      })
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-fields" },
              [
                _c("div", { staticClass: "input-fields__header" }, [
                  _c("h3", {
                    domProps: {
                      textContent: _vm._s(_vm.translations.input_password)
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-fields__content" },
                  [
                    _c("input-field", {
                      staticClass: "booking-field booking-field--mail",
                      attrs: {
                        name: _vm.translations.input_password,
                        "input-type": "password",
                        value: _vm.password
                      },
                      on: {
                        input: function(val) {
                          return (_vm.password = val)
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.pw_errors.password
                  ? _c(
                      "msg-block",
                      { attrs: { type: "error" } },
                      _vm._l(_vm.pw_errors.password, function(error) {
                        return _c("p", [
                          _c("b", { domProps: { textContent: _vm._s(error) } })
                        ])
                      })
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-fields" },
              [
                _c("div", { staticClass: "input-fields__header" }, [
                  _c("h3", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.translations.input_password_confirm
                      )
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-fields__content" },
                  [
                    _c("input-field", {
                      staticClass: "booking-field booking-field--mail",
                      attrs: {
                        name: _vm.translations.input_password_confirm,
                        "input-type": "password",
                        value: _vm.confirm_password
                      },
                      on: {
                        input: function(val) {
                          return (_vm.confirm_password = val)
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.pw_errors.confirm_password
                  ? _c(
                      "msg-block",
                      { attrs: { type: "error" } },
                      _vm._l(_vm.pw_errors.confirm_password, function(error) {
                        return _c("p", [
                          _c("b", { domProps: { textContent: _vm._s(error) } })
                        ])
                      })
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("button", {
                  staticClass: "btn btn--info",
                  class: { "item-loading": _vm.pwLoading },
                  attrs: { disabled: _vm.pwLoading },
                  domProps: {
                    textContent: _vm._s(_vm.translations.save_new_password_btn)
                  },
                  on: { click: _vm.changePw }
                }),
                _vm._v(" "),
                _vm.pwError
                  ? _c("msg-block", { attrs: { type: "error" } }, [
                      _c("p", [
                        _c("b", {
                          domProps: { textContent: _vm._s(_vm.pwError) }
                        })
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.pwSucess
                  ? _c("msg-block", { attrs: { type: "success" } }, [
                      _c("p", [
                        _c("b", {
                          domProps: {
                            textContent: _vm._s(_vm.translations.pw_success_msg)
                          }
                        })
                      ])
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53e63964", { render: render, staticRenderFns: staticRenderFns })
  }
}